// @flow

import React, { Component } from 'react'

import './FilterButton.css'

type Props = {
  generateReportClicked: Function,
  status: String
}

/**
  * Button for generate report
  * @class
  * @extends Component
*/
class GenerateReportButton extends Component<Props> {
  constructor (props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.handleClick = this.handleClick.bind(this)

    this.state = {
      toggle: false
    }
  }

  /** @func handleClick */
  handleClick () {
    if (this.props.generateReportClicked) {
      this.props.generateReportClicked()
      this.toggle()
    }
  }

  /** @func toggle */
  toggle () {
    this.setState(prevState => ({
      toggle: !prevState.toggle
    }))
  }

  /** render function */
  render () {
    let resultMessage = ''
    let button = ''
    let contentMessage = 'Your report is being processed and will be sent to your email shortly.'

    if (this.props.status === 'FAIL') {
      resultMessage = 'Error'
      contentMessage = 'Please try to process the report again or contact Customer Success for assistance.'
      button = <a href='mailto:customercare@theemployeeapp.com' className='modalEmailButton genReportButton'>Email Customer Care</a>
    }

    const modal = (
      <div className='backdropStyle' onClick={this.toggle}>
        <div className='modalStyle'>
          <h4 className='headerModal'>{resultMessage} Generating Report</h4>
          <div className='modalContent'>
            <div className='contentMessage'>{contentMessage}</div>
            <div>{button}</div>
          </div>
          <div className='modal-footer'>
            <button className='modalButton genReportButton'>Okay</button>
          </div>
        </div>
      </div>
    )
    return (
      <div>
        <button className='genReportButton' onClick={this.handleClick}>Generate Report</button>
        { this.state.toggle ? modal : '' }
      </div>
    )
  }
}

export default GenerateReportButton
